import { useEffect, useMemo } from 'react';

type Props = {
  title: string;
};
export const DocumentTitle = ({ title }: Props) => {
  const originalTitle = useMemo(() => document.title, []);

  useEffect(() => {
    // eslint-disable-next-line functional/immutable-data
    document.title = title;

    return () => {
      // eslint-disable-next-line functional/immutable-data
      document.title = originalTitle;
    };
  }, []);

  return null;
};
